import { SearchTypesList } from './SearchTypesList'

export default function SearchTypesSelector(props) {
  return (
    <div className='shop-types hidden-xs'>
      <SearchTypesList {...props} />
    </div>
  )
}
